import { getMonth, getYear } from 'date-fns/esm';
import _ from 'lodash';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { formats } from '~/helper';
import useGlobalContext from '~/view-data/use-global-context';
import useFetch from './use-fetch';
import useHeader from './use-header';
import api from '~/services/api';
import { showMessage } from '~/helper';

const initialData = {
  title: 'Events',
  cardOptions: {
    color: (row) => {
      if (row.status === 'accreditation') return 'cyan';
      if (row.status === 'checklist') return 'orange';
      if (row.status === 'running') return 'violet';
      if (row.status === 'finished') return 'lightgreen';
      return 'gold';
    },
    title: 'name',
    subtitle: (row) => {
      if (row.status === 'new') {
        return formats.dateTimeZone(row.accreditationStartDate, 'dd/MM/yyyy');
      }
      if (row.status === 'accreditation') {
        return formats.dateTimeZone(row.accreditationStartDate, 'dd/MM') + ' - '+ formats.dateTimeZone(row.accreditationEndDate, 'dd/MM');
      }
      return formats.dateTimeZone(row.eventDate, 'dd/MM/yyyy');
    },
    detail: 'eventType.name',
    info: 'place.name'
  },
  data: {
    boards: [],
    cards: []
  }
}

function useEvents() {
  const { state: { events = initialData }, dispatch } = useGlobalContext(),
    { state: headerState, actions: headerActions } = useHeader(),
    history = useHistory();

  useEffect(() => {
    let now =  new Date();
    headerActions.callFilter({ month: getMonth(now), year: getYear(now) });
    // eslint-disable-next-line
  }, []);

  const { data = { boards: [], cards: []} } = useFetch({ url: 'events/list', params: _.get(headerState, 'filter.data') });

  useEffect(() => {
    headerActions.configure({
      title: 'Eventos',
      count: 'none',
      loading: events.loading
    });
    // eslint-disable-next-line
  }, [events.data.cards, events.loading, headerState.filter.data]);


  function list(params) {
    headerActions.callFilter(params);
  };

  const changeStatus = async (eventId, status) => {
    try {
      await api.put(`events/change-status`, { eventId, status });
      showMessage('success', `Fase alterada com sucesso!`);

      if (/^(checklist)$/.test(status)) {
        return history.push(`/events/accredit-approval/${eventId}`);
      } else if (/^(running)$/.test(status)) {
        return history.push(`/events/running/${eventId}`);
      }
      history.push(`/events/${eventId}`);
    } catch (error) {
      failure(error);
    }
  };

  const load = (canWrite, canAccredit, { isSupplier }) => (data = {}) => {
    if (isSupplier) {
      return history.push(`/events/accredit/${data.id}`);
    }
    if (/^(checklist)$/.test(data.status)) {
      return history.push(`/events/accredit-approval/${data.id}`);
    }
    if (/^(finished|running)$/.test(data.status)) {
      return history.push(`/events/${data.status}/${data.id}`);
    }
    if (!canWrite) {
      return;
    }
    history.push(`/events/${data.id || 'new'}`);
  };

  const failure = (error) => {
    dispatch({ type: 'events', payload: { loading: false } });
    showMessage('error', error);
  };

  return {
    state: {
      ...events,
      loading: !data,
      data: data || {},
    },
    actions: {
      load,
      list,
      changeStatus,
    }
  }
}

export default useEvents;